import { TsrctQuoteItemStatus } from '@/generated/gql/graphql';

export const CROSSED_OUT_CLASSNAME = 'crossed-out';

export const QUOTE_ITEM_STATE_TO_CLASS_NAME: Record<TsrctQuoteItemStatus, string> = {
  [TsrctQuoteItemStatus.NOT_REQUESTED]: CROSSED_OUT_CLASSNAME,
  [TsrctQuoteItemStatus.REQUESTED]: CROSSED_OUT_CLASSNAME,
  [TsrctQuoteItemStatus.BID_PROVIDED]: '',
  [TsrctQuoteItemStatus.BID_DECLINED]: CROSSED_OUT_CLASSNAME,
  [TsrctQuoteItemStatus.AGREEMENT_REACHED]: '',
  [TsrctQuoteItemStatus.NEGOTIATION_FAILED]: CROSSED_OUT_CLASSNAME,
  [TsrctQuoteItemStatus.AWARDED]: '',
  [TsrctQuoteItemStatus.OFFER_DISMISSED]: '',
  [TsrctQuoteItemStatus.FINAL_OFFER_PROPOSED]: '',
};
